"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All searchbar translations for the ESN
var SearchBar = {
  search_keyword: {
    nl: 'Ondernemingen, categorieën, ...',
    fr: 'Entreprises, catégories, ...',
    en: 'Enterprises, categories, ...',
    de: 'Unternehmen, Kategorien, ...'
  },
  search_location: {
    nl: 'Postcode, Gemeente, deelgemeente, ...',
    fr: 'Code postal, Municipalité, district, ...',
    en: 'Postalcode, Municipality, sub municipality, ...',
    de: 'Postleitzahl, Gemeinde, Teilgemeinde, ...'
  },
  selected_location_single: {
    nl: 'geselecteerde locatie',
    fr: 'emplacement sélectionné',
    en: 'selected location',
    de: 'ausgewählter Standort'
  },
  selected_location_multi: {
    nl: 'geselecteerde locaties',
    fr: 'emplacements sélectionnés',
    en: 'selected locations',
    de: 'ausgewählte Standorte'
  },
  btb_info: {
    nl: 'B2B: Ondernemingen die producten en / of diensten aan andere bedrijven leveren.',
    fr: 'B2B: Entreprises qui fournissent des produits et / ou des services à d’autres entreprises.',
    en: 'B2B: Enterprises that supply products and / or services to other companies.',
    de: 'B2B: Unternehmen, die Produkte und / oder Dienstleistungen an andere Unternehmen liefern.'
  },
  btc_info: {
    nl: 'B2C: Ondernemingen die producten en / of diensten leveren aan consumenten.',
    fr: 'B2C: Entreprises qui fournissent des produits et / ou des services aux consommateurs.',
    en: 'B2C: Enterprises that provide products and / or services to consumers.',
    de: 'B2C: Unternehmen, die Produkte und / oder Dienstleistungen an Verbraucher liefern.'
  },
  location_is_empty: {
    nl: 'Geef minstens één locatie door',
    fr: 'Veuillez ajouter au moins un lieu',
    en: 'Please add at least one location',
    de: 'Bitte geben Sie mindestens einen Standort an'
  }
};
var _default = SearchBar;
exports["default"] = _default;